import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';
import template from './sign-in.component.html';
var SignInComponentController = /** @class */ (function () {
    function SignInComponentController() {
        this.loading = false;
        this.webStoreApiClient = getWebStoreApiClient();
    }
    Object.defineProperty(SignInComponentController.prototype, "label", {
        get: function () {
            var _a;
            return (_a = this.customLabel) !== null && _a !== void 0 ? _a : "SignIn" /* SignIn */;
        },
        enumerable: false,
        configurable: true
    });
    SignInComponentController.prototype.getMessage = function () {
        return !this.webStoreApiClient.account
            ? this.guestDeniedMessage
            : this.authorizedDeniedMessage;
    };
    SignInComponentController.prototype.onSignIn = function () {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.webStoreApiClient.signIn();
    };
    SignInComponentController.$inject = [];
    return SignInComponentController;
}());
export var SignInComponent = {
    bindings: {
        customLabel: '<',
        guestDeniedMessage: '<?',
        authorizedDeniedMessage: '<?',
    },
    controller: SignInComponentController,
    template: template,
};
